import React, { useState, useContext } from "react";
import { Controller } from "react-hook-form";
import { IonLabel, IonItem, IonSelect, IonSelectOption } from "@ionic/react";
import { useIntl } from "react-intl";
import useDeepCompareEffect from "use-deep-compare-effect";
import { listEmployees } from "../../api/server";
import RestrictedContext from "../util/RestrictedContext";
import { getFullName } from "../util/helpers";
import SkeltonItemContent from "./SkeltonItemContent";
import { useSelector } from "react-redux";

const EmployeeSelect = (props) => {
  const {
    name,
    control,
    rules,
    label,
    disabled,
    type,
    category,
    params,
    identfierId,
    proffesional,
    loading,
    onDataChanged,
    ...rest
  } = props;

  const intl = useIntl();
  const employee = useSelector(
    (state) => state.auth.profile.associated_employee
  );

  const [data, setData] = useState([{ ...employee }]);
  const restricted = useContext(RestrictedContext);

  useDeepCompareEffect(() => {
    listEmployees({ ...params }).then(({ error, data }) => {
      if (data) {
        setData(data.items);
      }
      if (onDataChanged) {
        onDataChanged(data.items);
      }
    });
  }, [params, {}]);

  const identfier = identfierId ? identfierId : "name";

  const getOptionLabel = (option) => {
    let name = getFullName(option.surename, option.first_name);
    if (option.professional_role_id) {
      const role = intl.formatMessage({
        id: `app.mobile.dataSelect.professional_role_id.${option.professional_role_id}`,
        defaultMessage: "",
      });
      name = proffesional ? name.concat(", ", role) : name;
    }
    return name;
  };

  return loading ? (
    <IonItem>
      <SkeltonItemContent />
    </IonItem>
  ) : (
    <IonItem>
      <IonLabel position="floating">{label}</IonLabel>
      <Controller
        control={control}
        rules={rules}
        render={({ field }) => {
          const { onChange, onBlur, value } = field;
          return (
            <IonSelect
              {...rest}
              value={value}
              disabled={disabled || !restricted["hasWritePermission"]}
              onIonChange={(e) => onChange(e.detail.value)}
              onBlur={onBlur}
              type={type}
              okText={intl.formatMessage({
                id: "app.mobile.actions.approve",
              })}
              cancelText={intl.formatMessage({
                id: "app.mobile.actions.cancel",
              })}
            >
              {data.map((option) => (
                <IonSelectOption key={option["id"]} value={option["id"]}>
                  {getOptionLabel(option)}
                </IonSelectOption>
              ))}
            </IonSelect>
          );
        }}
        name={name}
      />
    </IonItem>
  );
};

export default EmployeeSelect;
